import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';

const ChangeTemplateTypeModal = ({
  idPlantilla,
  showChangeTemplateTypeModal,
  handleShowChangeTemplateTypeModal,
  handleChangeTemplateType
}) => {
  const changeTemplateType = async () => {
    handleChangeTemplateType(idPlantilla);
  };

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={() => handleShowChangeTemplateTypeModal(false)}
      primaryAction={async () => {
        changeTemplateType();
        handleShowChangeTemplateTypeModal(false);
      }}
      primaryActionLabel="Modificar Solicitud"
      secondaryAction={() => handleShowChangeTemplateTypeModal(false)}
      secondaryActionLabel="Cancelar"
      show={showChangeTemplateTypeModal}
      size="md"
      title="Modificar tipo de solicitud"
      variantHeader="danger"
    >
      <div className="modal_body_error">
        <strong>
          Esta acción borrará todo el contenido generado hasta ahora. ¿Estas seguro de querer
          modificar el tipo de solicitud?
        </strong>
      </div>
    </ModalGeneric>
  );
};

ChangeTemplateTypeModal.propTypes = {
  idPlantilla: PropTypes.number.isRequired,
  showChangeTemplateTypeModal: PropTypes.bool.isRequired,
  handleShowChangeTemplateTypeModal: PropTypes.func.isRequired,
  handleChangeTemplateType: PropTypes.func.isRequired
};

export default ChangeTemplateTypeModal;
